module.exports = __webpack_public_path__ + "img/primary.ede076e.svg";